import { render } from "./PhotoStatsHeader.vue?vue&type=template&id=7d5e5cfc&scoped=true"
import script from "./PhotoStatsHeader.vue?vue&type=script&lang=js"
export * from "./PhotoStatsHeader.vue?vue&type=script&lang=js"

import "./PhotoStatsHeader.vue?vue&type=style&index=0&id=7d5e5cfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5e5cfc"]])

export default __exports__